import { fleetManagementApi } from "../api";

const BOOKINGS_ENDPOINT = "/bookings";

export const getAllBookings = async () => {
  const response = await fleetManagementApi.get(BOOKINGS_ENDPOINT);
  return response;
}

export const createBooking = async (bookingData) => {
  const response = await fleetManagementApi.post(BOOKINGS_ENDPOINT, bookingData);
  return response;
}

export const updateBooking = async ({ bookingId, bookingData }) => {
  const response = await fleetManagementApi.patch(`${BOOKINGS_ENDPOINT}/${bookingId}`, bookingData);
  return response;
}

export const confirmBooking = async ({ bookingId, payload }) => {
  const response = await fleetManagementApi.put(`${BOOKINGS_ENDPOINT}/${bookingId}/confirm`, payload);
  return response;
}

export const getAvailableDrivers = async (params) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await fleetManagementApi.get(`${BOOKINGS_ENDPOINT}/drivers/availability?${queryParams}`);
  return response;
}

export const completeBooking = async ({ bookingId, payload }) => {
  const response = await fleetManagementApi.put(`${BOOKINGS_ENDPOINT}/${bookingId}/complete`, payload);
  return response;
}

export const cancelBooking = async ({bookingId, payload}) => {
  const response = await fleetManagementApi.put(`${BOOKINGS_ENDPOINT}/${bookingId}/cancel`, payload);
  return response;
}